import { useState } from "react"
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Box } from '@material-ui/core';
import clsx from 'clsx';
import { CreatorTableHeader } from "../../../atoms/tables/dashboardTableHeader";
import { CreatorTableSubBody } from "../../../atoms/tables/dashboardTableSubBody";
import { CREATOR_TABLE_SUBHEADER, CREATOR_TABLE_HEADER, CREATOR_TABLE_HEADER_WITH_USER} from '../../../../config/mock';
import { CreatorTableBody } from "../../../atoms/tables/dashboardTableBody";

const useStyles = makeStyles(() => ({
  body: {
    position: 'sticky',
    marginBottom: 20
  },
  row: {
    background: '#fff',
  },
  bg: {
    background: '#F2F7FC!important',
  },
  borderRadius10: {
    borderRadius: 10,
    boxShadow: '0px 0px 4px #00000033',
  },
  borderRadiusBottom: {
    borderRadius: '0px 0px 10px 10px'
  },
  card: {
    boxShadow: '0px 0px 4px #00000033',
    borderRadius: 10,
    background:"#fff"
  },
}));

const CreatorTable = (props: any) => {

  const classes = useStyles();
  const [open, setOpen] = useState<number>(-1);
  const { sessions, userColumn } = props;

  const TableExperience = () => {
    return (
      <div className={clsx(open === -1 && classes.card)}>
        <CreatorTableHeader
          {...props}
          data={userColumn ? CREATOR_TABLE_HEADER_WITH_USER : CREATOR_TABLE_HEADER}
        />
        <TableContent
          {...props}
          open={open}
          setOpen={setOpen}
          data={sessions}
          userColumn={userColumn}
        />
      </div>
    )
  };

  return (
    <div>
      {sessions?.length > 0 && <TableExperience />}
      {!sessions &&
      <Grid container alignItems={'center'} justifyContent={'center'}>
        <Box m={3}>No experience!</Box>
      </Grid>
      }
    </div>
  )
};

export default CreatorTable;

const TableContent = (props: any) => {

  const classes = useStyles();
  const { selected, disableNavigation, onChangeSelected, sessions, userColumn, open } = props;
  const [initialHover, setInitialHover] = useState<any>('');
  const [clipRowHover, setClipRowHover] = useState<any>('');

  return (
    <div className={clsx(classes.body)}>
      {
        sessions.map((item: any, index: number) =>
          <div
            key={index}
            className={clsx(
              classes.row,
              item.session_id === open && classes.borderRadius10,
              index === sessions.length - 1 && classes.borderRadiusBottom,
              (initialHover === item.session_id && open !== item.session_id) && classes.bg
            )}
            onMouseOver={()=>setInitialHover(item.session_id)}
            onMouseLeave={()=>setInitialHover('')}
          >

            <CreatorTableBody
              HEADER={userColumn ? CREATOR_TABLE_HEADER_WITH_USER : CREATOR_TABLE_HEADER}
              item={item}
              userColumn={userColumn}
              initialHover={initialHover}
              {...props}
            />

            {
              item.session_id === open &&
              <div style={{ marginBottom: 22, background: '#E4E9EF' }}>
                <CreatorTableHeader data={CREATOR_TABLE_SUBHEADER} sub={true}/>

                {item.clips.map((clip: any, k: number) =>
                  <div
                    key={k}
                    onMouseOver={() => setClipRowHover(clip.clip_id)}
                    onMouseLeave={() => setClipRowHover('')}
                  >
                    <CreatorTableSubBody
                      key={k}
                      HEADER={CREATOR_TABLE_SUBHEADER}
                      clip={clip}
                      selected={selected}
                      disableNavigation={disableNavigation}
                      onChangeSelected={onChangeSelected}
                      title={item.session_title}
                      experienceStart={item.start}
                      sessionTrim={item.session_trim_from}
                      hoverIndex={clipRowHover}
                      session_code={item.session_code}
                      session_type={item.session_type}
                      {...props}
                    />
                  </div>
                )}
              </div>
            }

          </div>)
      }
    </div>

  )
}